module.exports = __webpack_public_path__ + "img/CM-SL-CA-Nissan-Lifestyle.bd28b891.jpeg";